import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M21 9.093v1.252a.63.63 0 0 1-.63.63H3.63a.63.63 0 0 1-.63-.63V5.127a.63.63 0 0 1 .63-.63h11.126c.021.437.099.86.225 1.26H4.259v3.958h15.482V9.25h.009c.432 0 .85-.055 1.25-.157Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M21 13.655a.63.63 0 0 0-.63-.63H8.117a.63.63 0 0 0-.63.63v5.218c0 .348.282.63.63.63H20.37a.63.63 0 0 0 .63-.63v-5.218Zm-12.254.63h10.995v3.958H8.746v-3.958ZM19.75 1.3a.7.7 0 0 1 .7.7v1.55H22a.7.7 0 1 1 0 1.4h-1.55V6.5a.7.7 0 1 1-1.4 0V4.95H17.5a.7.7 0 1 1 0-1.4h1.55V2a.7.7 0 0 1 .7-.7Z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=AddNestedSubItemIcon24.js.map